import React from 'react';
import { usePoints } from '../context/PointsContext';
import { motion, AnimatePresence } from 'framer-motion';

const PointsAnimation = () => {
    const { animations } = usePoints();

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            pointerEvents: 'none',
            zIndex: 9999,
            overflow: 'hidden'
        }}>
            <AnimatePresence>
                {animations.map((anim) => (
                    <motion.div
                        key={anim.id}
                        initial={{ opacity: 0, y: anim.y, x: anim.x, scale: 0.5 }}
                        animate={{ opacity: 1, y: anim.y - 100, scale: 1.2 }}
                        exit={{ opacity: 0, y: anim.y - 150, scale: 1 }}
                        transition={{ duration: 1, ease: "easeOut" }}
                        style={{
                            position: 'absolute',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '5px',
                            color: '#FFD700',
                            fontWeight: 'bold',
                            fontSize: '24px',
                            textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                        }}
                    >
                        <i className="fas fa-coins" style={{ color: '#FFD700', fontSize: '28px' }}></i>
                        <span>+{anim.amount}</span>
                    </motion.div>
                ))}
            </AnimatePresence>
        </div>
    );
};

export default PointsAnimation;
